module.exports = __webpack_public_path__ + "img/diagram.cb85d5dc.png";